import { render } from "./DeliverablesListing.vue?vue&type=template&id=6b1cff8c&scoped=true"
import script from "./DeliverablesListing.vue?vue&type=script&lang=js"
export * from "./DeliverablesListing.vue?vue&type=script&lang=js"

import "./DeliverablesListing.vue?vue&type=style&index=0&id=6b1cff8c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1cff8c"]])

export default __exports__